import { render, staticRenderFns } from "./PerformanceBasePage.vue?vue&type=template&id=478d55ea&scoped=true"
import script from "./PerformanceBasePage.vue?vue&type=script&lang=js"
export * from "./PerformanceBasePage.vue?vue&type=script&lang=js"
import style0 from "./PerformanceBasePage.vue?vue&type=style&index=0&id=478d55ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478d55ea",
  null
  
)

export default component.exports